module.exports = new __parcel__URL__("Team-Avatars.4f1b07ad.svg").toString();